//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "requisition-sap-flow",
    props: ['dataId', 'flowState', 'editable', 'workflowRequestLogList'],
    components: {
    },
    data() {
        return {
            userInfo: {},
            purRequisitionSap: {},
            requisition: { plant: {} },
            operate: [],
            turnoverLevel: '',
            turnoverRate: '',
            workflowLogList: []
        }
    },
    methods: {
        valid() {
            if ((!this.flowState || this.flowState === 's2' || this.flowState === 's1')
                && this.userInfo.code !== this.purRequisitionSap.applicant.code) { // 等于发起节点
                return false;
            }
            return true;
        },
        formData() {
            if (this.operate && this.operate.length > 0) {
                switch (this.operate[0]) {
                    case '同意':
                        this.purRequisitionSap.operate = '1';
                        break;
                    case '拒绝':
                        this.purRequisitionSap.operate = '2';
                        break;
                }
            }
            return this.purRequisitionSap;
        },
        getInfo() {
            this.$loadingShow();
            this.$get(`api/purRequisitionSap/${this.dataId}`).then((res) => {
                if (res) {
                    this.purRequisitionSap = res;
                    this.requisition = res.requisition;
                    this.turnoverLevel = res.level;
                    this.turnoverRate = res.turnoverRate;
                    switch (res.operate) {
                        case '1':
                            this.operate = ["同意"];
                            break;
                        case '2':
                            this.operate = ["拒绝"];
                            break;
                    }
                }
                this.$loadingHide();
            }).catch(() => {
                this.$loadingHide();
            })
        },
        getIsSupplier() {
            this.$get('api/person/current').then((data) => {
                this.userInfo = data;
            })
        }
    },
    mounted() {
        this.workflowLogList = this.workflowRequestLogList.map((oneLog) => {
            return {
                src: oneLog.user.headImage || require('../../assets/icon/touxiang.png'),
                fallbackSrc: require('../../assets/icon/touxiang.png'),
                title: oneLog.user.userName,
                desc: oneLog.remark
            }
        });
        this.getInfo();
        this.getIsSupplier();
    }
}



// WEBPACK FOOTER //
// ./src/page/requisition-sap-flow/requisition-sap-flow.vue